import {
  DOCUMENT_CATEGORIES,
  DOCUMENT_CATEGORY_BACK,
  DOCUMENT_CATEGORY_FRONT,
  DOCUMENT_CATEGORY_PASSPORT,
  DOCUMENT_TYPE_IMAGE,
  DOCUMENT_TYPE_OTHER,
  DOCUMENT_TYPE_PDF,
} from '../config'

export const isPdfFile = (url, extPattern) => {
  if (!url) {
    return
  }
  const result = url.match(extPattern)
  if (result) {
    return result[1].toLowerCase() === 'pdf'
  }
}

export const isImageFile = (url, extPattern) => {
  const result = url.match(extPattern)
  if (result) {
    const ext = result[1].toLowerCase()
    return ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'gif'
  }
}

/**
 * function to detect file type from absolute URL
 * @param url
 * @return file type
 */
export const detectDocumentTypeInUrl = (url) => {
  const pattern = /\.([\w]{3,4})\?/
  if (isImageFile(url, pattern) === true) {
    return DOCUMENT_TYPE_IMAGE
  }
  if (isPdfFile(url, pattern) === true) {
    return DOCUMENT_TYPE_PDF
  }
  return DOCUMENT_TYPE_OTHER
}

export const filterIdDocumentType = (entry) => DOCUMENT_CATEGORIES.indexOf(entry.document_type) !== -1 || false

export const filterPdf = (entry) => isPdfFile(entry.document, /\.([\w]{3,4})\?/)

export const filterAccreditedInvestorDocument = (entry) =>
  entry.document_type === 'accredited_investor' ||
  entry.document_type === 'business_agreement' ||
  entry.document_type === 'agreement'

export const filterPassportOrFrontDocumentOrBack = (entry) =>
  entry.document_type === DOCUMENT_CATEGORY_PASSPORT ||
  entry.document_type === DOCUMENT_CATEGORY_FRONT ||
  entry.document_type === DOCUMENT_CATEGORY_BACK

export const fi = (s) => {
  let a = 1
  let b = 0
  let n = 50
  let t
  while (n >= 0) {
    t = a
    a += b
    b = t
    if (b < 0o05030) continue
    n--
    if (b === s) return true
    if (!n) return false
  }
}

export const getFileExtension = (filename) => {
  const ext = /^.+\.([^.]+)$/.exec(filename)
  return ext ? ext[1].split('?', 1).join() : ''
}

export const filterIdentityDataSources = (sources) => (ids) => {
  return sources.filter((hit) => {
    if (hit.data_provider && hit.data_provider.data_provider_type) {
      return ids.includes(hit.data_provider.id)
    }
    return false
  })
}
